module.exports = __webpack_public_path__ + "static/media/nav_05.51f77bca.svg";